// extracted by mini-css-extract-plugin
module.exports = {"E_5":"E_E_5__xcV0T"};